import GlobalAccountsTableView from './table/global-accounts-table-view';

export default function GlobalAccounts() {
  return <GlobalAccountsTableView />;
}
